module.exports = __webpack_public_path__ + "static/media/img_delete.dbec3999.svg";